export const modulePracticeDetails = {
  1: {
    assignment: {
      practiceKeys: ['practice1-1'],
      prompts: [
        {
          text: 'Spend at least 15 minutes of child-centered time with your child(ren) each day. Watch how they react to this time with you!',
        },
        {
          text: 'Try descriptive commenting at least once.',
        },
        {
          text: 'You picked to practice {practice1-1} as a routine, practice it regularly.',
          practiceKeys: ['practice1-1'],
        },
      ],
    },
    review: {
      recordName: '1',
      valueKeys: [
        'practiceRev1-1',
        'practiceRev1-2',
        'practiceRev1-3',
        'practiceRev1-4',
        'practiceRev1-5',
      ],
      questions: [
        {
          key: 'practiceRev1-1',
          text: 'Spend at least 15 minutes of child-centered time every day:',
        },
        {
          key: 'practiceRev1-2',
          text: 'I was able to spend child-centered time with my child:',
        },
        {
          key: 'practiceRev1-3',
          text: 'What were some of the child centered activities that you did?',
        },
        {
          key: 'practiceRev1-4',
          text: 'Use descriptive commenting at least once.',
        },
        {
          key: 'practiceRev1-5',
          text: 'Start a new routine with my child, it was: {practice1-1}',
          practiceKeys: ['practice1-1'],
        },
      ],
    },
  },
  2: {
    assignment: {
      practiceKeys: ['top-5', 'practice2-2'],
      prompts: [
        {
          text: 'Continue to spend at least 15 minutes every day in child-centered time. This activity can include reading with your child.',
        },
        {
          text: 'Use labeled praise every time you see your child: {top-5}',
          practiceKeys: ['top-5'],
        },
        {
          text: 'Praise another adult (for example, your partner, child’s day care teacher, or a coworker) for something he or she did well.',
        },
        {
          text: 'In the module activity, you chose {practice2-2} as challenging behaviors that you are working on. Develop a reward program or reward to help your child.',
          practiceKeys: ['practice2-2'],
        },
      ],
    },
    review: {
      recordName: '2',
      valueKeys: [
        'practiceRev2-1',
        'practiceRev2-2',
        'practiceRev2-3',
        'practiceRev2-4',
        'practiceRev2-5',
        'practiceRev2-6',
        'practiceRev2-7',
      ],
      questions: [
        {
          key: 'practiceRev2-1',
          text: 'Spend at least 15 minutes of child-centered time every day:',
        },
        {
          key: 'practiceRev2-2',
          text: 'I was able to spend child-centered time with my child:',
        },
        {
          key: 'practiceRev2-3',
          text: 'What were some of the child centered activities that you did?',
        },
        {
          key: 'practiceRev2-4',
          text: 'Use labeled praise for a behavior I wanted to see more from my child.',
        },
        {
          key: 'practiceRev2-5',
          text: 'Use labeled praise with another adult in my life.',
        },
        {
          key: 'practiceRev2-6',
          text: 'Started a reward program with my child for: {practice2-2}',
          practiceKeys: ['practice2-2'],
        },
        {
          key: 'practiceRev2-7',
          text: 'What was the reward?',
        },
      ],
    },
  },
  3: {
    assignment: {
      practiceKeys: ['ds-practice-1'],
      prompts: [
        {
          text: 'Continue to spend at least 15 minutes every day in child-centered time. This activity can include reading with your child.',
        },
        {
          text: 'Review the list of household rules you made : {ds-practice-1}. Reduce the number of instructions and commands to those things that are on your list of Household Rules.',
          practiceKeys: ['ds-practice-1'],
        },
        {
          text: 'Use do statements and warning statements. Make sure you keep it simple and clear!',
        },
      ],
    },
    review: {
      recordName: '3',
      valueKeys: [
        'practiceRev3-1',
        'practiceRev3-2',
        'practiceRev3-3',
        'practiceRev3-4',
        'practiceRev3-5',
      ],
      questions: [
        {
          key: 'practiceRev3-1',
          text: 'Spend at least 15 minutes of child-centered time every day:',
        },
        {
          key: 'practiceRev3-2',
          text: 'I was able to spend child-centered time with my child:',
        },
        {
          key: 'practiceRev3-3',
          text: 'What were some of the child centered activities that you did?',
        },
        {
          key: 'practiceRev3-4',
          text: 'Use do statements and warning statements.',
        },
        {
          key: 'practiceRev3-5',
          text: 'Reduce the number of instructions to those that were really important.',
        },
      ],
    },
  },
  4: {
    assignment: {
      practiceKeys: ['ignore-TYN-1a'],
      prompts: [
        {
          text: 'Continue to spend at least 15 minutes every day in child-centered time. This activity can include reading with your child.',
        },
        {
          text: 'Give at least one natural if/then statement.',
        },
        {
          text: 'Give at least one logical if/then statement.',
        },
        {
          text: 'Give at least one when/then statement.',
        },
        {
          text: 'Look at the list of behaviors that you thought you could ignore. {ignore-TYN-1a}: Pick one of the behaviors that you think you can ignore. Then ignore the misbehavior every time you see it happen.',
          practiceKeys: ['ignore-TYN-1a'],
        },
      ],
    },
    review: {
      recordName: '4',
      valueKeys: [
        'practiceRev4-1',
        'practiceRev4-2',
        'practiceRev4-3',
        'practiceRev4-4',
        'practiceRev4-5',
        'practiceRev4-6',
      ],
      questions: [
        {
          key: 'practiceRev4-1',
          text: 'Spend at least 15 minutes of child-centered time every day:',
        },
        {
          key: 'practiceRev4-2',
          text: 'I was able to spend child-centered time with my child:',
        },
        {
          key: 'practiceRev4-3',
          text: 'What were some of the child centered activities that you did?',
        },
        {
          key: 'practiceRev4-4',
          text: 'Give at least one natural if/then statement.',
        },
        {
          key: 'practiceRev4-5',
          text: 'Give at least one logical if/then statement.',
        },
        {
          key: 'practiceRev4-6',
          text: 'Give at least one when/then statement.',
        },
      ],
    },
  },
  5: {
    assignment: {
      practiceKeys: ['practice-to1', 'mod-5-pr-1'],
      prompts: [
        {
          text: 'Continue to spend at least 15 minutes every day in child-centered time. This activity can include reading with your child.',
        },
        {
          text: 'You picked {practice-to1} as the behavior that you want to stop with a time-out (remember, these behaviors should be misbehaviors that don’t stop with a simple, clear do statement and is specific and clear to the child).',
          practiceKeys: ['practice-to1'],
        },
        {
          text: 'Plan ahead where you will have your child take a time-out. Make sure it is a safe place where you can see the child and they will not be distracted. {mod-5-pr-1}',
          practiceKeys: ['mod-5-pr-1'],
        },
        {
          text: 'Explain time-out to your child. Make sure you pick a time to explain time-outs when you and your child are calm.',
        },
        {
          text: 'Use time-out the next time your child does the misbehavior. Make sure you end the time-out on a positive note.',
        },
      ],
    },
    review: {
      recordName: '5',
      valueKeys: [
        'practiceRev5-1',
        'practiceRev5-2',
        'practiceRev5-3',
        'practiceRev5-4',
        'practiceRev5-6',
        'practiceRev5-7',
      ],
      questions: [
        {
          key: 'practiceRev5-1',
          text: 'Spend at least 15 minutes of child-centered time every day:',
        },
        {
          key: 'practiceRev5-2',
          text: 'I was able to spend child-centered time with my child:',
        },
        {
          key: 'practiceRev5-3',
          text: 'What were some of the child centered activities that you did?',
        },
        {
          key: 'practiceRev5-4',
          text: 'Explain time-out to my child.',
        },
        {
          key: 'practiceRev5-6',
          text: 'Use time-out when my child: {practice-to1}',
          practiceKeys: ['practice-to1'],
        },
        {
          key: 'practiceRev5-7',
          text: 'Follow the 8 Keys to Effective Discipline.',
        },
      ],
    },
  },
  6: {
    assignment: {
      practiceKeys: ['p-practice-2', 'mod-6-pr-1'],
      prompts: [
        {
          text: 'Continue to spend at least 15 minutes every day in child-centered time. This activity can include reading with your ',
        },
        {
          text: 'Look at the list you made of things that leave you feeling really stressed as a parent. {p-practice-2} Pick one of the things from this list and come up with a plan for managing the stress.',
          practiceKeys: ['p-practice-2'],
        },
        {
          text: 'Use one or more of the stress reduction strategies: Take 5 Breathing Exercise, Planning Ahead, Parent Time-Out, Mind Jars for Calming the Mind, and Reframing Affirmations',
        },
        {
          text: 'Pick a problem at home or at work that you want to work on using the steps to problem- solving. Write the problem below in a positive way: {mod-6-pr-1}, then use the Guidelines for Problem-Solving to try and solve this problem.',
          practiceKeys: ['mod-6-pr-1'],
        },
      ],
    },
    review: {
      recordName: '6',
      valueKeys: [
        'practiceRev6-1',
        'practiceRev6-2',
        'practiceRev6-3',
        'practiceRev6-4',
        'checkGroup',
        'practiceRev6-6',
      ],
      questions: [
        {
          key: 'practiceRev6-1',
          text: 'Spend at least 15 minutes of child-centered time every day:',
        },
        {
          key: 'practiceRev6-2',
          text: 'I was able to spend child-centered time with my child:',
        },
        {
          key: 'practiceRev6-3',
          text: 'What were some of the child centered activities that you did?',
        },
        {
          key: 'practiceRev6-4',
          text: 'Pick one of the things that cause me stress and make a plan for reducing stress.',
        },
        {
          key: 'checkGroup',
          text: 'Here are the strategies I used (check all that apply)',
        },
        {
          key: 'practiceRev6-6',
          text: 'Use the Guidelines for Problem-Solving to solve a problem.',
        },
      ],
    },
  },
};

export const moduleProgressDetailsTemplate = [
  {
    module: 1,
    moduleName: 'Child-Centered Time, Routines, & Traditions',
    items: [
      {
        sectionName: 'Child Centered Time',
        items: [
          {
            id: 'check1-1',
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Teaching Through Play and Descriptive Commenting',
        items: [
          {
            id: 'check1-2',
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Family Routines and Traditions',
        items: [
          {
            id: 'badge11',
            name: 'Activity | Rockin Routines',
            type: 'activity',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Reading as Routine',
        items: [
          {
            id: 'check1-3',
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
          {
            id: 'practice1-1',
            name: 'Selected Routine',
            type: 'practice_assignment',
            dateCompleted: null,
            data: null,
          },
        ],
      },
      {
        sectionName: 'Wrap Up',
        items: [
          {
            id: 'badge12',
            name: 'Completion Badge',
            type: 'badge',
            dateCompleted: null,
          },
          {
            //eop ratings
            id: 17,
            backendId: null,
            name: 'Survey Rating',
            type: 'survey_rating',
            dateCompleted: null,
            rating: null,
          },
        ],
      },
      {
        sectionName: 'Practice Assignment',
        items: [
          {
            id: 18,
            backendId: null,
            name: 'Practice Assignment',
            type: 'practice_assignment',
            practiceKeys: modulePracticeDetails[1].assignment.practiceKeys,
            prompts: modulePracticeDetails[1].assignment.prompts,
            dateCompleted: null,
            text: 'Praise another adult (for example, your partner, child’s day care teacher, or a coworker) for something he or she did well.',
          },
        ],
      },
      {
        sectionName: 'Practice Review',
        items: [
          {
            id: 19,
            backendId: null,
            name: 'Practice Review',
            type: 'practice_review',
            reviewRecordName: modulePracticeDetails[1].review.recordName,
            reviewKeys: modulePracticeDetails[1].review.valueKeys,
            questions: modulePracticeDetails[1].review.questions,
            dateCompleted: null,
            data: null,
          },
        ],
      },
    ],
  },
  {
    module: 2,
    moduleName: 'Using Praise, Encouragement, and Rewards',
    items: [
      {
        sectionName: 'Labeled Praise',
        items: [
          {
            id: 21,
            backendId: null,
            name: 'Activity: How Do You Want Your Child to Feel?',
            type: 'activity',
            dateCompleted: null,
          },
          {
            id: 22,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
          {
            id: 23,
            backendId: null,
            name: 'Activity: Labeled Versus Unlabeled Praise',
            type: 'activity',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName:
          'If You Want To See a Behavior Again, Give It Your Attention!',
        items: [
          {
            id: 24,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
          {
            id: 25,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Using Rewards for Challenging Behaviors',
        items: [
          {
            id: 26,
            backendId: null,
            name: 'Activity: Reward Program',
            type: 'activity',
            dateCompleted: null,
          },
          {
            id: 27,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Using Rewards, Not Bribes!',
        items: [
          {
            id: 28,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
          {
            id: 29,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Wrap Up',
        items: [
          {
            id: 210,
            backendId: null,
            name: 'Completion Badge',
            type: 'badge',
            dateCompleted: null,
          },
          {
            id: 211,
            backendId: null,
            name: 'Survey Rating',
            type: 'survey_rating',
            dateCompleted: null,
            extraText: null,
          },
        ],
      },
      {
        sectionName: 'Practice Assignment',
        items: [
          {
            id: 212,
            backendId: null,
            name: 'Practice Assignment',
            type: 'practice_assignment',
            practiceKeys: modulePracticeDetails[2].assignment.practiceKeys,
            prompts: modulePracticeDetails[2].assignment.prompts,
            dateCompleted: null,
            data: null,
          },
        ],
      },
      {
        sectionName: 'Practice Review',
        items: [
          {
            id: 213,
            backendId: null,
            name: 'Practice Review',
            type: 'practice_review',
            reviewRecordName: modulePracticeDetails[2].review.recordName,
            reviewKeys: modulePracticeDetails[2].review.valueKeys,
            questions: modulePracticeDetails[2].review.questions,
            dateCompleted: null,
            data: null,
          },
        ],
      },
    ],
  },
  {
    module: 3,
    moduleName: 'Do Statements',
    items: [
      {
        sectionName: 'DO Statements',
        items: [
          {
            id: 31,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
          {
            id: 32,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
          {
            id: 33,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
          {
            id: 34,
            backendId: null,
            name: 'Activity - DO Statements',
            type: 'activity',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Following Through on Expectations',
        items: [
          {
            id: 35,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Warning Statements',
        items: [
          {
            id: 36,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Wrap Up',
        items: [
          {
            id: 37,
            backendId: null,
            name: 'Completion Badge',
            type: 'badge',
            dateCompleted: null,
          },
          {
            id: 38,
            backendId: null,
            name: 'Survey Rating',
            type: 'survey_rating',
            dateCompleted: null,
            extraText: null,
          },
        ],
      },
      {
        sectionName: 'Practice Assignment',
        items: [
          {
            id: 39,
            backendId: null,
            name: 'Practice Assignment',
            type: 'practice_assignment',
            practiceKeys: modulePracticeDetails[3].assignment.practiceKeys,
            prompts: modulePracticeDetails[3].assignment.prompts,
            dateCompleted: null,
            data: null,
          },
        ],
      },
      {
        sectionName: 'Practice Review',
        items: [
          {
            id: 310,
            backendId: null,
            name: 'Practice Review',
            type: 'practice_review',
            reviewRecordName: modulePracticeDetails[3].review.recordName,
            reviewKeys: modulePracticeDetails[3].review.valueKeys,
            questions: modulePracticeDetails[3].review.questions,
            dateCompleted: null,
            data: null,
          },
        ],
      },
    ],
  },
  {
    module: 4,
    moduleName: 'Setting Limits and Managing Behavior',
    items: [
      {
        sectionName: 'Natural If/Then Statements',
        items: [
          {
            id: 41,
            backendId: null,
            name: 'Activity - Natural If/Then Statements',
            type: 'activity',
            dateCompleted: null,
          },
          {
            id: 42,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Logical If/Then Statements',
        items: [
          {
            id: 43,
            backendId: null,
            name: 'Activity: Logical If/Then Statements',
            type: 'activity',
            dateCompleted: null,
          },
          {
            id: 44,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'When/Then Statements',
        items: [
          {
            id: 45,
            backendId: null,
            name: 'Activity: When/Then Statements',
            type: 'activity',
            dateCompleted: null,
          },
          {
            id: 46,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Ignore',
        items: [
          {
            id: 47,
            backendId: null,
            name: 'Activity: What Behavior Can YOU Ignore?',
            type: 'activity',
            dateCompleted: null,
          },
          {
            id: 48,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
          {
            id: 49,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Distract',
        items: [
          {
            id: 410,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
          {
            id: 411,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Wrap Up',
        items: [
          {
            id: 412,
            backendId: null,
            name: 'Completion Badge',
            type: 'badge',
            dateCompleted: null,
          },
          {
            id: 413,
            backendId: null,
            name: 'Survey Rating',
            type: 'survey_rating',
            dateCompleted: null,
            extraText: null,
          },
        ],
      },
      {
        sectionName: 'Practice Assignment',
        items: [
          {
            id: 414,
            backendId: null,
            name: 'Practice Assignment',
            type: 'practice_assignment',
            practiceKeys: modulePracticeDetails[4].assignment.practiceKeys,
            prompts: modulePracticeDetails[4].assignment.prompts,
            dateCompleted: null,
            data: null,
          },
        ],
      },
      {
        sectionName: 'Practice Review',
        items: [
          {
            id: 415,
            backendId: null,
            name: 'Practice Review',
            type: 'practice_review',
            reviewRecordName: modulePracticeDetails[4].review.recordName,
            reviewKeys: modulePracticeDetails[4].review.valueKeys,
            questions: modulePracticeDetails[4].review.questions,
            dateCompleted: null,
            data: null,
          },
        ],
      },
    ],
  },
  {
    module: 5,
    moduleName: 'Effective Discipline and Time-Outs',
    items: [
      {
        sectionName: 'Using Time-Out: Step 2',
        items: [
          {
            id: 51,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
          {
            id: 52,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
          {
            id: 53,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Using Time-Out: Step 3',
        items: [
          {
            id: 54,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
          {
            id: 55,
            backendId: null,
            name: 'Activity: Common Concerns About Using Time-Out',
            type: 'activity',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Time-Out in a Public Place',
        items: [
          {
            id: 56,
            backendId: null,
            name: 'Activity: Time-Outs in Public',
            type: 'activity',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Wrap Up',
        items: [
          {
            id: 57,
            backendId: null,
            name: 'Completion Badge',
            type: 'badge',
            dateCompleted: null,
          },
          {
            id: 58,
            backendId: null,
            name: 'Survey Rating',
            type: 'survey_rating',
            dateCompleted: null,
            extraText: null,
          },
        ],
      },
      {
        sectionName: 'Practice Assignment',
        items: [
          {
            id: 59,
            backendId: null,
            name: 'Practice Assignment',
            type: 'practice_assignment',
            practiceKeys: modulePracticeDetails[5].assignment.practiceKeys,
            prompts: modulePracticeDetails[5].assignment.prompts,
            dateCompleted: null,
            data: null,
          },
        ],
      },
      {
        sectionName: 'Practice Review',
        items: [
          {
            id: 510,
            backendId: null,
            name: 'Practice Review',
            type: 'practice_review',
            reviewRecordName: modulePracticeDetails[5].review.recordName,
            reviewKeys: modulePracticeDetails[5].review.valueKeys,
            questions: modulePracticeDetails[5].review.questions,
            dateCompleted: null,
            data: null,
          },
        ],
      },
    ],
  },
  {
    module: 6,
    moduleName: 'Reducing Stress and Problem Solving',
    items: [
      {
        sectionName: 'Parenting Stress',
        items: [
          {
            id: 61,
            backendId: null,
            name: 'Activity: What Causes You Stress As A Parent?',
            type: 'activity',
            dateCompleted: null,
          },
          {
            id: 62,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Reducing Stress',
        items: [
          {
            id: 63,
            backendId: null,
            name: 'Activity : Reframing',
            type: 'activity',
            dateCompleted: null,
          },
          {
            id: 64,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Problem Solving',
        items: [
          {
            id: 65,
            backendId: null,
            name: 'Activity: "You" vs "I" Statements',
            type: 'activity',
            dateCompleted: null,
          },
          {
            id: 66,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
          {
            id: 67,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
          {
            id: 68,
            backendId: null,
            name: 'Knowledge Check',
            type: 'knowledge_check',
            dateCompleted: null,
          },
        ],
      },
      {
        sectionName: 'Wrap Up',
        items: [
          {
            id: 69,
            backendId: null,
            name: 'Completion Badge',
            type: 'badge',
            dateCompleted: null,
          },
          {
            id: 610,
            backendId: null,
            name: 'Survey Rating',
            type: 'survey_rating',
            dateCompleted: null,
            extraText: null,
          },
        ],
      },
      {
        sectionName: 'Practice Assignment',
        items: [
          {
            id: 611,
            backendId: null,
            name: 'Practice Assignment',
            type: 'practice_assignment',
            practiceKeys: modulePracticeDetails[6].assignment.practiceKeys,
            prompts: modulePracticeDetails[6].assignment.prompts,
            dateCompleted: null,
            data: null,
          },
        ],
      },
      {
        sectionName: 'Practice Review',
        items: [
          {
            id: 612,
            backendId: null,
            name: 'Practice Review',
            type: 'practice_review',
            reviewRecordName: modulePracticeDetails[6].review.recordName,
            reviewKeys: modulePracticeDetails[6].review.valueKeys,
            questions: modulePracticeDetails[6].review.questions,
            dateCompleted: null,
            data: null,
          },
        ],
      },
    ],
  },
];
